var map = {
	"./archive/backup.bos.json": "./src/config/archive/backup.bos.json",
	"./archive/backup.pbi.json": "./src/config/archive/backup.pbi.json",
	"./bos.json": "./src/config/bos.json",
	"./djt.json": "./src/config/djt.json",
	"./globals.json": "./src/config/globals.json",
	"./lna.json": "./src/config/lna.json",
	"./pbi.json": "./src/config/pbi.json",
	"./syd.json": "./src/config/syd.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/.*\\.json$";